<template>
  <MarketplaceForm :item="item" :default-item-data="item_data" :new-store-fn="newStoreWb" :edit-store-fn="editStoreWb" @storeSuccess="$emit('storeSuccess')">
    <template #top>
      <div class="col mb-3">
        <DocLink docKey="marketplace_wb" text="Посмотреть инструкцию по подключению Wildberries" />
      </div>
    </template>
    <template #connection="{item_data}">
      <div class="col mb-4">
        <label class="form-label">Токен</label>
        <div class="input-group">
          <input :type="tokenVisible ? 'text' : 'password'" name="connection[token]" class="form-control" placeholder="" required
                 v-model="item_data.connection.token">
          <span class="input-group-text cursor-pointer" @click="toggleTokenVisibility">
            <i class="ti" :class="tokenVisible ? 'ti-eye-off' : 'ti-eye'"></i>
          </span>
        </div>
      </div>
    </template>
    <template #settings="{item_data}">
      <div class="col mb-4">
        <label class="form-label">Коэффициент локализации (число от 0.5 до 2, зависит от индекса локализации,
          склада)</label>
        <input type="text" name="settings[local_coefficient]" class="form-control" placeholder=""
               v-model="item_data.settings.local_coefficient">
      </div>
      <div class="col mb-4">
        <label class="form-label">Среднее время доставки (начисляется доп. комиссия)</label>
        <input type="text" name="settings[delivery_hours]" class="form-control" placeholder=""
               v-model="item_data.settings.delivery_hours">
      </div>
      
      <h6 class="mb-1 mt-4">Настройки FBS</h6>
      <div class="col mb-4">
        <label class="form-label">Склад отгрузки обычных товаров</label>
        <Select
          v-model="item_data.settings.wb_warehouse_code"
          :options="warehousesForFbs"
          optionLabel="_label"
          optionValue="code"
          :filter="true"
          placeholder="Выберите склад"
          class="w-100"
          :loading="loadingWarehouses"
        />
      </div>
      <div class="col mb-4">
        <label class="form-label">Склад отгрузки СГТ товаров</label>
        <Select
          v-model="item_data.settings.wb_warehouse_sgt_code"
          :options="warehousesForFbs"
          optionLabel="_label"
          optionValue="code"
          :filter="true"
          placeholder="Выберите склад"
          class="w-100"
          :loading="loadingWarehouses"
        />
      </div>
      
      <h6 class="mb-1 mt-4">Настройки FBW</h6>
      <div class="col mb-4">
        <label class="form-label">Тип поставки</label>
        <Select
          v-model="item_data.settings.wb_supply_type"
          :options="wbSupplyTypes"
          optionLabel="label"
          optionValue="value"
          placeholder="Выберите тип поставки"
          class="w-100"
          @change="() => onSupplyTypeChange(item_data)"
        />
      </div>
      <div class="col mb-4">
        <label class="form-label">Склад отгрузки FBW товаров</label>
        <Select
          v-model="item_data.settings.wb_fbo_warehouse_code"
          :options="getWarehousesForFbo(item_data)"
          optionLabel="_label"
          optionValue="code"
          :filter="true"
          placeholder="Выберите склад"
          class="w-100"
          :loading="loadingWarehouses"
        />
      </div>
    </template>
  </MarketplaceForm>
</template>
<script>
import {editStoreWb, newStoreWb, getWbWarehouses} from "@/api/store";
import MarketplaceForm from "@/components/forms/MarketplaceForm.vue";
import Select from 'primevue/select';
import DocLink from "@/components/tools/DocLink.vue";

export default {
  name: "WbForm",
  components: {MarketplaceForm, Select, DocLink},
  data() {
    return {
      tokenVisible: false,
      loadingWarehouses: false,
      warehouses: [],
      wbSupplyTypes: [{
        value: 'box',
        label: 'Короб'
      }, {
        value: 'pallet',
        label: 'Монопаллета'
      }],
      item_data: {
        id: '',
        name: '',
        company: '',
        marketplace: 'wb',
        connection: {
          token: '',
        },
        settings: {
          model: 'fbs',
          fixed_commission: 30,
          percent_commission: 0,
          local_coefficient: 1,
          delivery_hours: 30,
          wb_warehouse_code: '',
          wb_warehouse_sgt_code: '',
          wb_fbo_warehouse_code: '',
          wb_supply_type: ''
        },
        schedule: {
          import_products: null,
          get_offers: [4, 16],
          get_orders: '60'
        }
      }
    }
  },
  props: ['item'],
  computed: {
    warehousesForFbs() {
      return this.warehouses.filter(w => w.is_for_fbs === true)
    }
  },
  methods: {
    newStoreWb, editStoreWb,
    toggleTokenVisibility() {
      this.tokenVisible = !this.tokenVisible;
    },
    async fetchWarehouses() {
      this.loadingWarehouses = true
      try {
        const res = await getWbWarehouses()
        this.warehouses = (res.data || []).map(w => ({...w, _label: `${w.name}`}))
      } catch (e) {
        this.warehouses = []
      }
      this.loadingWarehouses = false
    },
    getWarehousesForFbo(item_data) {
      if (!item_data || !item_data.settings) {
        return this.warehouses
      }
      const supplyType = item_data.settings.wb_supply_type
      if (supplyType === 'box') {
        return this.warehouses.filter(w => w.is_for_fbo_box === true)
      } else if (supplyType === 'pallet') {
        return this.warehouses.filter(w => w.is_for_fbo_pallet === true)
      }
      return this.warehouses
    },
    onSupplyTypeChange(item_data) {
      if (!item_data || !item_data.settings) {
        return
      }
      // При изменении типа поставки проверяем, соответствует ли выбранный склад
      if (item_data.settings.wb_fbo_warehouse_code) {
        const supplyType = item_data.settings.wb_supply_type
        let filteredWarehouses = []
        
        if (supplyType === 'box') {
          filteredWarehouses = this.warehouses.filter(w => w.is_for_fbo_box === true)
        } else if (supplyType === 'pallet') {
          filteredWarehouses = this.warehouses.filter(w => w.is_for_fbo_pallet === true)
        } else {
          filteredWarehouses = this.warehouses
        }
        
        const selectedWarehouse = filteredWarehouses.find(w => w.code === item_data.settings.wb_fbo_warehouse_code)
        if (!selectedWarehouse) {
          // Выбранный склад не соответствует новому типу поставки, очищаем
          item_data.settings.wb_fbo_warehouse_code = ''
        }
      }
    }
  },
  async mounted() {
    await this.fetchWarehouses()
  }
}
</script>